(function () {

  'use strict';

  function pxGoogle(
    $window, $http, $rootScope, $location, $filter, $timeout, toastr, URLS,
    EventServiceEvents, IdpProviderService, IdpContextMenuMixin
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=',
        me: '='
      },
      templateUrl: 'app/components/authenticationSettings/google/google.template.html',
      link: function (scope) {

        const TYPE = 'google';
        const idpModel = {
          name: null,
          unConnected: true,
          groupSynchTaskId: null,
          hasIssues: false,
          groupSyncState: 'NONE',
          scimConfig: null,
          info: {
            admin_consent_granted: null,
            domains: [],
            groups_enabled: null,
            idp_tenant_identifier: null,
            _links: null
          }
        };

        scope.descriptor = IdpProviderService.descriptorByType(TYPE);
        scope.tenantIdentityProviders = [];

        IdpContextMenuMixin.attach(scope);

        (function () {
          setListeners();
          mapIdentityProviders();
          checkForProviderIssues();
        })();

        function providersForType() {
          return scope.tenant.info._embedded.tenantIdentityProviders.providers[TYPE];
        }

        function mapIdentityProviders() {
          scope.tenantIdentityProviders = IdpProviderService.directoriesFor(scope.tenant, TYPE);
        }

        function checkForProviderIssues() {
          angular.forEach(scope.tenant.info._embedded.openIssues, function (issue) {
            if (issue.type === 'GROUP_SYNCHRONIZATION_STOPPED') {
              angular.forEach(scope.tenantIdentityProviders, function (idp) {
                if (issue._links['px:directories'] && idp.info._links) {
                  if (issue._links['px:directories'].href === idp.info._links.self.href) {
                    idp.hasIssues = true;
                  }
                }
              });
            }
          });
        }

        scope.addIdpTemplate = function () {
          scope.tenantIdentityProviders.push(angular.copy(idpModel));
        };

        scope.connectToIdp = function () {
          const activationUrl = providersForType()._links['px:tenant_activation_link'].href;
          const domainUrl = $location.absUrl().split('/admin');
          const activationUrlAndRedirect = activationUrl + domainUrl[0] + URLS.TEST_IDENTITY_PROVIDERS;
          $http.get(activationUrlAndRedirect).then(function (response) {
            $window.open(response.data.authentication_url, '_blank');
          }).catch(function () {});
        };

        scope.synchronizeGroups = function (identityProvider) {
          const groupSyncUrl = identityProvider.info._links['px:enable_groups'].href;
          const domainUrl = $location.absUrl().split('/admin');
          $window.tenantId = scope.tenant.customProperties.id;
          $window['px:identityProvider'] = identityProvider.info;
          $window.groupTestUrl = groupSyncUrl;
          $http.get(groupSyncUrl + domainUrl[0] + URLS.GROUPS_TEST_PAGE).then(function (response) {
            $window.open(response.data.href, '_blank');
          }).catch(function () {});
        };

        scope.acceptIdentityForAllUsers = function (identityProvider) {
          const acceptAllUsersUrl = identityProvider.info._links['px:grant_admin_consent'].href;
          const domainUrl = $location.absUrl().split('/admin');
          $http.get(acceptAllUsersUrl + domainUrl[0] + '/admin/app/components/authenticationSettings/MSIdentity/accept.html').then(function (response) {
            $window.open(response.data.href, '_blank');
          }).catch(function () {});
        };

        function getNewIdentityProviderDirectory(directoryUrl) {
          $http.get(directoryUrl).then(function (response) {
            if (scope.tenantIdentityProviders[scope.tenantIdentityProviders.length - 1].unConnected === true) {
              scope.tenantIdentityProviders.splice(scope.tenantIdentityProviders.length - 1, 1);
            }
            const newInfo = {
              admin_consent_granted: response.data.admin_consent_granted,
              domains: response.data.domains,
              groups_enabled: response.data.groups_enabled,
              idp_tenant_identifier: response.data.idp_tenant_identifier,
              _links: response.data._links
            };
            scope.tenantIdentityProviders.push({
              name: response.data.name,
              unConnected: false,
              info: newInfo,
              groupSyncState: IdpProviderService.groupSyncStateOf(newInfo)
            });
            providersForType().directories[response.data.name] = response.data;
            toastr.success($filter('translate')('ConnectionVerified'));
            $timeout(function () {
              toastr.success($filter('stringular')($filter('translate')('ConnectedToIdentityProvider'), response.data.name));
            }, 300);
          }).catch(function () {});
        }

        function updateIdentityProviderDirectory(directoryUrl, updateType) {
          $http.get(directoryUrl).then(function (response) {
            for (let i = 0; i < scope.tenantIdentityProviders.length; i++) {
              if (scope.tenantIdentityProviders[i].info._links.self.href === directoryUrl) {
                if (updateType === 'ADMIN_CONSENT_GRANTED') {
                  toastr.success($filter('translate')('AcceptedForAllUsers'));
                } else {
                  toastr.success($filter('translate')('ChangesSaved'));
                }
                scope.tenantIdentityProviders[i].info = response.data;
                scope.tenantIdentityProviders[i].groupSyncState = IdpProviderService.groupSyncStateOf(response.data);
              }
            }
            const directories = providersForType().directories;
            directories[response.data.primary_domain] = response.data;
            for (const key in directories) {
              if (Object.prototype.hasOwnProperty.call(directories, key) &&
                  directories[key]._links.self.href === directoryUrl) {
                directories[key] = response.data;
              }
            }
            scope.tenant.info.groupsEnabled = scope.tenant.isGroupsEnabled(scope.tenant.info);
          }).catch(function () {});
        }

        function removeIdentityProviderDirectory(directoryUrl) {
          const providersUrl = providersForType()._links.self.href;
          $http.get(providersUrl).then(function (response) {
            if (!response.data.directories) {
              response.data.directories = {};
            }
            const deletedProviderId = directoryUrl.split('/').pop();
            const index = scope.tenantIdentityProviders.findIndex(function (provider) {
              return provider.info.idp_tenant_identifier === deletedProviderId;
            });
            if (index === -1) {
              return;
            }
            scope.tenantIdentityProviders.splice(index, 1);
            const directories = {};
            const dirs = providersForType().directories;
            for (const key in dirs) {
              if (Object.prototype.hasOwnProperty.call(dirs, key) &&
                  typeof dirs[key] === 'object' &&
                  dirs[key].idp_tenant_identifier !== deletedProviderId) {
                directories[key] = dirs[key];
              }
            }
            if (!scope.tenantIdentityProviders.length) {
              providersForType().directories = response.data.directories;
              mapIdentityProviders();
            } else {
              providersForType().directories = directories;
            }
          }).catch(function () {
            toastr.error($filter('translate')('ERROR'));
          });
        }

        function setListeners() {
          const events = EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS;

          scope.$on(events.IDENTITY_PROVIDER_CREATED, function (name, data) {
            getNewIdentityProviderDirectory(data.directory);
          });

          scope.$on(events.IDENTITY_PROVIDER_UPDATED, function (name, data) {
            updateIdentityProviderDirectory(data.directory, data.update);
          });

          scope.$on(events.IDENTITY_PROVIDER_DELETED, function (name, data) {
            removeIdentityProviderDirectory(data.directory);
          });

          scope.$on(events.IDENTITY_PROVIDER_WARNING, function () {});

          scope.$on(events.IDENTITY_PROVIDER_ERROR, function (name, data) {
            const response = { data: null };
            try {
              const has = Object.prototype.hasOwnProperty;
              if (has.call(data, 'errorCode') &&
                  has.call(data, 'parameterizedErrorText') &&
                  has.call(data, 'parameters') &&
                  has.call(data, 'errorText')) {
                response.data = data;
              } else {
                throw new Error('(data) is missing required attributes');
              }
            } catch (error) {
              response.data = {
                errorCode: 'UNKNOWN_ERROR',
                parameterizedErrorText: 'Unknown error',
                parameters: [],
                errorText: 'Unknown error'
              };
            }
            $rootScope.$broadcast('REQUEST_ERROR_HELP', { error: response });
          });
        }

      }
    };
  }

  pxGoogle.$inject = [
    '$window', '$http', '$rootScope', '$location', '$filter', '$timeout', 'toastr', 'URLS',
    'EventServiceEvents', 'IdpProviderService', 'IdpContextMenuMixin'
  ];

  angular
    .module('printix-admin')
    .directive('pxGoogle', pxGoogle);

})();
